document.addEventListener('DOMContentLoaded', () => {
  const productSection = document.querySelector('[data-main-product]');
  if (!productSection) return;

  function updateSizeState() {
    const selectedBlouseOption = productSection.querySelector(
      'input[name="blouse option"]:checked'
    );

    const sizeInputs = productSection.querySelectorAll(
      'input[name="size"]'
    );

    const isUnstitched =
      selectedBlouseOption?.value.trim().toLowerCase() === 'unstitched';

    sizeInputs.forEach((input) => {
      input.disabled = isUnstitched;
      const label = input.parentElement.querySelector(
        `label[for="${input.id}"]`
      );
      label.classList.toggle(
        'custom-size-option--disabled',
        isUnstitched
        );
    });
  }

  productSection.addEventListener('change', (event) => {
    if (
      event.target.matches(
        'input[name="blouse option"]'
      )
    ) {
      requestAnimationFrame(updateSizeState);
    }
  });

  updateSizeState();
});